import { render, staticRenderFns } from "./Manually.vue?vue&type=template&id=d4bca77a&scoped=true"
import script from "./Manually.vue?vue&type=script&lang=js"
export * from "./Manually.vue?vue&type=script&lang=js"
import style0 from "./Manually.vue?vue&type=style&index=0&id=d4bca77a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bca77a",
  null
  
)

export default component.exports